module.exports = __webpack_public_path__ + "static/media/Image02.1343dfd0.png";